import axios from "axios";
import { Toast } from "../utils/commonImports";

const liveEnvironment = false
export const apiUrl = liveEnvironment ? "https://changan.deepdms.net/api/" : "https://changanuat.deepdms.net/api/"

const axiosInstance = axios.create({
   baseURL: apiUrl
});

const getAuthHeaders = () => {
  const key = JSON.parse(localStorage.getItem("x_t"));
  return {
    'Authorization': `Bearer ${key?.t || ""}`,
    'Content-Type': "application/json",
  };
};

export const _api = async (method, url, data = null, callback) => {
  try {
    const config = {
      method: method,
      url: url,
      headers: getAuthHeaders(),
    };

    if (method === 'POST' || method === 'PUT') {
      config.data = data;
    }

    const response = await axiosInstance(config);

    if (response && (response.status === 200 || response.status === 201)) {
      callback(response.data);
    } else {
      callback({ isSuccess: false, message: response?.data?.message || 'Unexpected response status' });
      Toast.fire({ icon: 'error', title: "Something went wrong", customClass: { popup: 'custom-toast-class' }});
    }
  } catch (error) {
    callback({
      isSuccess: false,
      message: error.response?.data?.message || 'API error',
    });
  }
};

// **********************Usage*************************

// _api('POST', 'PortalUserAPI/Add', postData, (res) => {
//   console.log(res);
// });

// _api('PUT', `PortalUserAPI/UpdatePortalUser/${id}`, updatedData, (res) => {
//   console.log(res);
// });

// _api('GET', 'PortalUserAPI/GetAllUsers', null, (res) => {
//   console.log(res);
// });

// _api('DELETE', `PortalUserAPI/DeleteUser/${id}`, null, (res) => {
//   console.log(res);
// });